<template>
  <!-- 配送列表 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button
            class="glo_btnItems glo_bgcMainColor"
            @click="qsBtns()"

          >批量签收</el-button
        >
<!--        v-if="hasPermiss('admin:delivery:batch:self:pick:up:sign:for')"-->


        <el-button
            class="glo_btnItems glo_bgcMainColor"
            @click="onOutgoing"

          >外发录入</el-button>
<!--        v-if="hasPermiss('admin:delivery:batch:exam:fee')"-->


        <el-button plain
                   class="glo_btnItems glo_bgcMainColor"
                   @click="onUpdateFinalHandoverModeDialog"

        >修改派送方式</el-button
        >
<!--        v-if="hasPermiss('hasPM')"-->

        <el-button plain class="glo_btnItems glo_bgcMainColor" @click="onUpdateReceiveAddrDialog"
        >修改派送地址</el-button
        >
        <el-button plain
                   class="glo_btnItems glo_bgcMainColor"
                   @click="cancelWithhold"

        >发货</el-button
        >
<!--        v-if="hasPermiss('admin:delivery:release:waybill')"-->


        <el-button plain
                   class="glo_btnItems glo_bgcMainColor"
                   @click="withhold"

        >取消发货</el-button
        >
        <!--        v-if="hasPermiss('admin:delivery:hold:waybill')"-->

        <el-button plain
                   class="glo_btnItems glo_bgcMainColor"
                   @click="cancelEndDelivery"

        >取消末端送货</el-button>
        <el-button plain
                   class="glo_btnItems glo_bgcMainColor"
                   @click="onCancelOutgoingDialog"

        >取消外发</el-button>


        <el-button class="itemBtn" @click="myModel"
        >表格设置</el-button
        >

        <template >
          <div class="tableExportBtn">
            <exportTb
                :theadData="myTableHeard"
                :tableData="tableData"
                :resultData="tableData"
                @handleExportDia_dc="handleExportDia_dc('配送列表')"
            ></exportTb>
          </div>
        </template>
      </div>
      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <!-- :formData="queryData" -->
    <queryCondition
      ref="queryForm"
      :More="isHaseMore"
      :formConfig="queryCondditionDatas"
    ></queryCondition>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
        :row-class-name="tableRowClassName"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <!-- 某个字段需要单独操作  例如点击可以跳转 -->
          <el-table-column
            v-if="item.field === 'aaaaaaaaaa' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="left"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div class="linkTabel">
                {{ scope.row.aaaaaaaaaa }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-else-if="item && item.isShow"
          ></el-table-column>
        </template>
        <el-table-column fixed="right" label="操作" min-width="310px">
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button class="rbtns" @click.stop="qsBtns(scope.row)"
                >签收</el-button
              >
              <el-button
                  size="small"
                  type="primary"
                  @click="onUploadAttachment(scope.row)"
              >上传签收附件</el-button
              >
              <el-button
                  size="small"
                  type="primary"
                  @click="onViewAnnex(scope.row)"
              >查看附件</el-button
              >
              <el-button class="rbtns" @click.stop="cancelSign(scope.row)"
                >取消签收</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>

    <!--        自定义表头           -->
    <sorttable
        :show_sortTableHeard="show_sortTableHeard"
        :allCheck="allCheck"
        :sortName="sortName"
        :tabelHeadeTitle="tabelHeadeTitle"
        :originalTabelHeadeTitle="originalTabelHeadeTitle"
        :selectLength="selectLength"
        @cancelSortHeard="cancelSortHeard"
        @confirmOk="confirmOk"
        @checktab="checktab"
        @checkAll="checkAll"
        @closeDias="closeDias"
    ></sorttable>

    <!-- 导出插件 -->
    <exportComponent
        :isShowDialog_dc="exportForm.isShowDialog_dc"
        :diaWidth_dc="exportForm.diaWidth_dc"
        :diaHeight_dc="exportForm.diaHeight_dc"
        :dialogTitle="exportForm.dialogTitle"
        :dialogForm_dc="exportForm.dialogForm_dc"
        :data="exportForm.queryForm"
        :tableHeard="exportForm.EPtableHeard"
        :AllCheck="exportForm.EPAllCheck"
        @checktabEP="checktabEP"
        @checkAllEP="checkAllEP"
        @onAfterEnter="onAfterEnter"
        @handleCloseDia_dc="handleCloseDia_dc"
        @diaConfirmBtn_dc="diaConfirmBtn_dc"
        queryType="exportModeList"
    >
    </exportComponent>



    <!-- 取消签收 -->
    <el-dialog
        title="取消签收"
        :visible.sync="cancel"
        width="40%"
        @close="cancelSignC"
    >
      <div class="titlebox">
        是否对以下{{ currentItemArr.length }}个打包批次号进行取消签收?
      </div>
      <div class="formbox">
        <el-form
            label-position="right"
            label-width="100px"
            :model="formLabelAlign"
        >
          <el-form-item label="打包批次号:">
            <el-input
                type="textarea"
                v-model="formLabelAlign.storePackNum"
                readonly
            ></el-input>
          </el-form-item>
          <el-form-item label="取消签收时间:">
            <el-input v-model="formLabelAlign.dateTime" readonly></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="cancelSignSub">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 外发录入 -->
    <el-dialog
        title="外发录入"
        :visible.sync="outgoingDialog"
        width="40%"
        @close="cancelOnOutgoing"
    >
      <div class="formbox">
        <el-form
            label-position="right"
            label-width="100px"
            :model="outgoingDialogData"
        >
          <el-form-item label="外发合作商:">
            <el-select
                v-model="outgoingDialogData.partnerChannleName"
                placeholder="请选择"
                @visible-change="visibleChange($event, 6)"
                @change="
                    onSelect(
                      $event,
                      partnerChannleNameOptions,
                      ['partnerChannleId', 'partnerChannleName'],
                      ['id', 'partnerName']
                    )
                  "
                clearable
                filterable
                remote
                :remote-method="(val) => getPartnerChannleList(val)"
            >
              <el-option
                  v-for="(item, index) in partnerChannleNameOptions"
                  :key="index"
                  :label="item.partnerName"
                  :value="item.id"
              />
            </el-select>

          </el-form-item>
          <el-form-item label="外发单号:">
            <el-input
                v-model="outgoingDialogData.outgoingNumber"
            ></el-input>
          </el-form-item>
          <el-form-item label="外发日期:">
            <el-date-picker
                style="width: 100%"
                v-model="outgoingDialogData.outgoingTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="选择日期时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="外发备注:">
            <el-input type="textarea" v-model="outgoingDialogData.outgoingRemarks" ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="outgoingSure">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="修改派送方式"
        :visible.sync="updateFinalHandoverModeDialog"
        width="40%"
        @close="cancelUpdateFinalHandoverModeDialog"
    >
      <div class="formbox">
        <el-form
            label-position="right"
            label-width="100px"
            :model="updateFinalHandoverModeDialogData"
        >
          <el-form-item label="修改派送方式:">
            <el-select
                filterable
                clearable
                @visible-change="getConfDictValDownList('handover_mode')"
                v-model="updateFinalHandoverModeDialogData.finalHandoverMode"
                placeholder="请选择"
            >
              <el-option
                  v-for="item in handoverModeList"
                  :label="item.val"
                  :key="item.key"
                  :value="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="末端派送渠道:">
            <el-select
                filterable
                clearable
                @visible-change="getDispatchChannleList()"
                v-model="updateFinalHandoverModeDialogData.dispatchChannelId"
                placeholder="请选择"
            >
              <el-option
                  v-for="item in dispatchChannelOptions"
                  :label="item.channelName"
                  :key="item.id + ''"
                  :value="item.id + ''"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注:">
            <el-input v-model="updateFinalHandoverModeDialogData.updateFinalHandoverModeRemarks" ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="updateFinalHandoverModeSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="修改派送地址"
        :visible.sync="updateReceiveAddrDialog"
        width="40%"
        @close="cancelUpdateReceiveAddrDialog"
    >
      <div class="formbox">
        <el-form
            label-position="right"
            label-width="100px"
            :model="updateReceiveAddrDialogData"
        >
          <el-form-item label="收件地址:">
            <el-input v-model="updateReceiveAddrDialogData.address" ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="updateReceiveAddrSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="取消外发"
        :visible.sync="cancelOutgoingDialog"
        width="40%"
        @close="cancelCancelOutgoingDialog"
    >
      <div class="formbox">
        <el-form
            label-position="right"
            label-width="100px"
            :model="cancelOutgoingDialogData"
        >
          <el-form-item label="入仓仓库:">
            <el-select
                filterable
                clearable
                @visible-change="getStorageList()"
                v-model="cancelOutgoingDialogData.intoStorageId"
                placeholder="请选择"
            >
              <el-option
                  v-for="item in cangkuList"
                  :label="item.storageName"
                  :key="item.id"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="onCancelOutgoingSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <Dialog
        :show="uploadAttachmentVisible"
        class="dialog-padding-container"
        :title="uploadAttachmentTitle"
        width="80%"
        @onCancel="uploadAttachmentCancel"
        :footer="false"
    >
      <commonFuJian
          :disabled="isdisabled"
          :addFiles="true"
          :delFilse="delFilse"
          :data="annexTable"
          @saveFile="uploadAttachmentConfirm"
          ref="uploadDomCommonFuJian"
      ></commonFuJian>
    </Dialog>
  </div>
</template>
  <script>
import tableList from "@/pages/DynamicList/tableList.js";
//   import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import queryBtns from "@/components/queryBtnsDT.vue";
import queryCondition from "@/components/queryCondition.vue";
import myDialog from "@/components/DialogDT.vue";
import { Message as ElMessage, MessageBox as ElMessageBox } from 'element-ui'
import utils from "@/assets/js/tool";
//   import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
import customerModelService from "@/components/customerService/modelIndex.vue";
import { Api } from "@/assets/js/api";
import commonFuJian from "@/components/fuJian/index.vue";
import exportTb from "@/components/exportComponent/exportTb.vue";
import exportComponent from "@/components/exportComponent/index.vue";
import tableListNew from "@/pages/tableListNew.js";
import sorttable from "@/components/sortTemplate.vue";

export default {
  mixins: [tableList,tableListNew],
  inject: ["reload"],
  components: {
    sorttable,
    exportComponent,
    exportTb,
    commonFuJian,
    //   sorttable,
    paging,
    queryBtns,
    queryCondition,
    myDialog,
    customerModelService,
  },
  data() {
    return {
      sortName: "配送列表",
      userList: [],

      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "配送列表", //导出时默认文件名
        apiName: "/v1/common/query/runPageReport", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd===等待下载完成,bdd===不等待完成
        apiType: "POST", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      pageGroupName: "DynamicListDeliveryList", //  页面标识
      reportFiledsNumber: "delivery_list", // 动态 条件、表头

      currentItemArr: [],
      dialogType: "",
      showTimers:false,
      dataList: [],
      oneDocuNumber: "",
      customerModelServiceStatus: false,
      cancel: false,
      formLabelAlign: {
        storePackIds: [],
        storePackNum: "",
        dateTime: "",
      },
      outgoingDialog: false,
      outgoingDialogData: {
        billPackIds: [],
        outgoingNumber:"",
        partnerChannleId:"",
        partnerChannleName:"",
        outgoingTime:"",
        outgoingRemarks:"",
      },

      updateFinalHandoverModeDialog: false,
      updateFinalHandoverModeDialogData: {
        billPackIds: [],
        finalHandoverMode:"",
        dispatchChannelId:"",
        updateFinalHandoverModeRemarks:"",
      },
      updateReceiveAddrDialog: false,
      updateReceiveAddrDialogData: {
        billPackIds: [],
        address:"",
      },

      cancelOutgoingDialog: false,
      cancelOutgoingDialogData: {
        billPackIds: [],
        intoStorageId: ""
      },
      cangkuList:  [],
      handoverModeList: [], //  提货方式
      partnerChannleNameOptions: [],
      dispatchChannelOptions: [],
      delFilse: false,
      uploadAttachmentVisible: false,
      uploadAttachmentTitle: "上传附件",
      fileRowData: {},
      isdisabled: true,
      annexTable: []
    };
  },
  mounted() {
    this.getData();
  },
  watch: {},
  created() {
    this.getConfDictValDownList("handover_mode"); //  提货方式
  },
  methods: {

    // 添加行样式类名的方法
    tableRowClassName({row, rowIndex}) {
      if (row.endDeliveryStatus === 1) {
        return 'delivery-completed-row';
      }
      return '';
    },
    // 表格选择事件
    handleSelectionChange(e) {
      this.currentItemArr = e || [];
    },

    // 不能输入负数
    minNum(val) {
      return val < 0 ? 0 : val;
    },
    //获取下拉列表
    getStorageList() {
      //获取仓库下拉列表
      Api.getStorageList().then((res) => {
        this.cangkuList = res.data.result || [];
      });
    },
    //  签收确认
    qsBtns(row) {
      let listCur = this.currentItemArr || [];
      if(row){
        listCur = [row];
      }
      if (listCur.length > 0) {
        console.log("listCur",listCur)
        let idArr = [];
        listCur.forEach((item) => {
          idArr.push(item.billStorepackId);
          console.log("item.billStorepackId",item.billStorepackId)
        });
        this.$confirm(
            `即将签收${
                listCur.length
            }个包裹, 签收时间：${this.myGetTime()}?`,
            "提示",
            {
              confirmButtonText: "签收确认",
              cancelButtonText: "取消",
              type: "warning",
            }
        ).then(() => {
          Api.signForConfirm({ storePackIds: idArr }).then((res) => {
            if (res.data.status === "success") {
              this.currentItemArr = [];
              this.getData();
              this.$message.success("签收成功");
            }
          });
        });
      } else {
        this.$message.error("请至少选择一条数据");
      }
    },

    //  取消签收
    cancelSign(row) {
      let listCur = this.currentItemArr;
      if(row){
        listCur = [row];
      }
      if (listCur.length > 0) {
        let arr = [];
        let billPackNumberStr = "";
        listCur.forEach((item) => {
          arr.push(item.billStorepackId);
          billPackNumberStr += item.billPackNumber + ",";
        });
        if (billPackNumberStr.length > 1) {
          billPackNumberStr = billPackNumberStr.substring(
              0,
              billPackNumberStr.lastIndexOf(",")
          );
        }
        this.formLabelAlign.storePackIds = arr;
        this.formLabelAlign.dateTime = this.myGetTime();
        this.formLabelAlign.storePackNum = billPackNumberStr;
        this.cancel = true;
      } else {
        this.$message.error("请选择一条数据");
      }
    },
    //  取消签收弹出层关闭的回调
    cancelSignC() {
      this.formLabelAlign = {
        storePackIds: [],
        storePackNum: "",
        dateTime: "",
      };
      this.cancel = false;
    },
    //  确认取消签收
    cancelSignSub() {
      Api.cancelSignFor({
        storePackIds: this.formLabelAlign.storePackIds,
      }).then((res) => {
        if (res.data.status === "success") {
          this.$message.success("取消签收成功");
          this.cancel = false;
          this.getData();
        }
      });
    },
    // 获取当前时间
    myGetTime() {
      let _date = "";
      let myDate = new Date();
      myDate.getFullYear(); //获取完整的年份
      myDate.getMonth() + 1; //获取当前月份
      myDate.getDate(); //获取当前日(1-31)
      _date = `${myDate.getFullYear()}-${
          myDate.getMonth() + 1
      }-${myDate.getDate()}`;
      return _date;
    },
    // 暂扣
    withhold() {
      let ids = [];
      if (this.currentItemArr.length < 1) {
        return false
      }
      this.$confirm(`确定把所选的${this.currentItemArr.length}个单据标记为扣货?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ids = this.currentItemArr.map(items => {
          return items.billPackId
        })

        Api.withhold({
          billPackIds: ids
        }).then(res => {
          this.$message.success(res.data.message || '操作成功')
        })

      })

    },
    // 取消暂扣
    cancelWithhold() {
      let ids = [];
      if (this.currentItemArr.length < 1) {
        return false
      }
      this.$confirm(`确定把所选的${this.currentItemArr.length}个单据发货?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ids = this.currentItemArr.map(items => {
          return items.billPackId
        })

        Api.cancelWithhold({
          billPackIds: ids
        }).then(res => {
          this.$message.success( '操作成功')
        })

      })
    },

    // 取消末端派送
    cancelEndDelivery() {
      let ids = [];
      if (this.currentItemArr.length < 1) {
        return false
      }
      this.$confirm(`确定把所选的${this.currentItemArr.length}个单据取消送货处理吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ids = this.currentItemArr.map(items => {
          return items.billPackId
        })

        Api.cancelEndDelivery({
          billPackIds: ids
        }).then(res => {
          this.$message.success(res.data.message || '操作成功')
        })

      })

    },

    //外发弹窗
    onOutgoing(){
      if (this.currentItemArr.length < 1) {
        ElMessage({
          message: "请选择单据",
          type: "error",
        });
        return false;
      }
      const idList = this.currentItemArr.map((item) => {
        return item.billPackId;
      })

      const currentItem = this.currentItemArr[0];
      this.outgoingDialogData.billPackIds = idList;
      this.outgoingDialogData.outgoingTime = utils.getCurrentTime();;
      this.outgoingDialogData.outgoingNumber = currentItem.outgoingNumber;
      this.outgoingDialogData.partnerChannleId = currentItem.partnerChannleId;
      this.outgoingDialogData.partnerChannleName = currentItem.partnerChannleName;
      this.outgoingDialogData.outgoingRemarks = currentItem.outgoingRemarks;

      this.outgoingDialog = true;
    },



    //  取消外发弹窗关闭的回调
    cancelOnOutgoing() {
      this.outgoingDialogData = {
        billPackIds: [],
        outgoingNumber:"",
        partnerChannleId:"",
        partnerChannleName:"",
        outgoingTime:"",
        outgoingRemarks:"",
      };
      this.outgoingDialog = false;
    },
    //外发录入
    outgoingSure() {
      Api.outgoing({
        billPackIds: this.outgoingDialogData.billPackIds,
        outgoingTime: this.outgoingDialogData.outgoingTime,
        outgoingNumber: this.outgoingDialogData.outgoingNumber,
        partnerChannleId: this.outgoingDialogData.partnerChannleId,
        partnerChannleName: this.outgoingDialogData.partnerChannleName,
        outgoingRemarks: this.outgoingDialogData.outgoingRemarks,
      }).then((res) => {
        if (res.data.status === "success") {
          this.$message.success("外发录入成功");
          this.outgoingDialog = false;
          this.getData();
        }
      });
    },

    //修改派送方式弹窗
    async onUpdateFinalHandoverModeDialog(){
      if (this.currentItemArr.length < 1) {
        ElMessage({
          message: "请选择单据",
          type: "error",
        });
        return false;
      }
      const idList = this.currentItemArr.map((item) => {
        return item.billPackId;
      })

      this.updateFinalHandoverModeDialogData.dispatchChannelId = "";
      const currentItem = this.currentItemArr[0];
      this.updateFinalHandoverModeDialogData.billPackIds = idList;
      this.updateFinalHandoverModeDialogData.finalHandoverMode = currentItem.finalHandoverMode;
      this.updateFinalHandoverModeDialogData.updateFinalHandoverModeRemarks = currentItem.updateFinalHandoverModeRemarks;
      // 先加载末端派送渠道列表，等待加载完成后再设置选中值
      await this.getDispatchChannleList();

      // 确保选项列表加载完成后再赋值，这样能正确显示名称
      this.$nextTick(() => {
        this.updateFinalHandoverModeDialogData.dispatchChannelId = currentItem.dispatchChannelId + "";
      });
      this.updateFinalHandoverModeDialog = true;
    },
    //  取消修改派送方式关闭的回调
    cancelUpdateFinalHandoverModeDialog() {
      this.updateFinalHandoverModeDialogData = {
        billPackIds: [],
        finalHandoverMode:"",
        dispatchChannelId:"",
        updateFinalHandoverModeRemarks:"",
      };
      this.updateFinalHandoverModeDialog = false;
    },

    //取消外发弹窗
    onCancelOutgoingDialog(){
      if (this.currentItemArr.length < 1) {
        ElMessage({
          message: "请选择单据",
          type: "error",
        });
        return false;
      }
      const idList = this.currentItemArr.map((item) => {
        return item.billPackId;
      })

      const currentItem = this.currentItemArr[0];
      this.cancelOutgoingDialogData.billPackIds = idList;
      this.cancelOutgoingDialog = true;
    },
    //  取消取消外发关闭的回调
    cancelCancelOutgoingDialog() {
      this.cancelOutgoingDialogData = {
        billPackIds: [],
        intoStorageId:"",
      };
      this.cancelOutgoingDialog = false;
    },

    //取消外发
    onCancelOutgoingSubmit() {
      Api.cancelOutgoing({
        billPackIds: this.cancelOutgoingDialogData.billPackIds,
        intoStorageId: this.cancelOutgoingDialogData.intoStorageId,
      }).then((res) => {
        if (res.data.status === "success") {
          this.$message.success("取消成功");
          this.cancelOutgoingDialog = false;
          this.getData();
        }
      });
    },

    //修改派送方式
    updateFinalHandoverModeSubmit() {
      Api.updateFinalHandoverMode({
        billPackIds: this.updateFinalHandoverModeDialogData.billPackIds,
        finalHandoverMode: this.updateFinalHandoverModeDialogData.finalHandoverMode,
        updateFinalHandoverModeRemarks: this.updateFinalHandoverModeDialogData.updateFinalHandoverModeRemarks,
        dispatchChannelId: this.updateFinalHandoverModeDialogData.dispatchChannelId,
      }).then((res) => {
        if (res.data.status === "success") {
          this.$message.success("修改成功");
          this.updateFinalHandoverModeDialog = false;
          this.getData();
        }
      });
    },
    //修改派送地址弹窗
    onUpdateReceiveAddrDialog(){
      if (this.currentItemArr.length < 1) {
        ElMessage({
          message: "请选择单据",
          type: "error",
        });
        return false;
      }
      const idList = this.currentItemArr.map((item) => {
        return item.billPackId;
      })

      const currentItem = this.currentItemArr[0];
      this.updateReceiveAddrDialogData.billPackIds = idList;
      this.updateReceiveAddrDialogData.address = currentItem.updateAddress;
      this.updateReceiveAddrDialog = true;
    },
    //  取消修改派送地址关闭的回调
    cancelUpdateReceiveAddrDialog() {
      this.updateReceiveAddrDialogData = {
        billPackIds: [],
        address:"",
      };
      this.updateReceiveAddrDialog = false;
    },
    //修改派送地址
    updateReceiveAddrSubmit() {
      Api.updateReceiveAddr({
        billPackIds: this.updateReceiveAddrDialogData.billPackIds,
        address: this.updateReceiveAddrDialogData.address,
      }).then((res) => {
        if (res.data.status === "success") {
          this.$message.success("修改成功");
          this.updateReceiveAddrDialog = false;
          this.getData();
        }
      });
    },

    changeFinalHandoverMode(e){
      let index =
          this.handoverModeList.findIndex((v) => v.cargoareaNumber === e) || 0;
      let ids = "";
      if (this.handoverModeList.length > 0 && this.handoverModeList[index]) {
        ids = this.handoverModeList[index].val;
      }
    },
    //上传签收附件弹窗
    async onUploadAttachment(row){
      this.annexTable = [];
      this.fileRowData = row;
      this.uploadAttachmentVisible = true;
      this.delFilse = true;
      this.isdisabled = false;
    },
    uploadAttachmentCancel() {
      this.uploadAttachmentVisible = false;
      this.annexTable = [];
      this.isdisabled = true;
      this.delFilse = false;
    },
    onViewAnnex(row) {
      let params7 = {
        billPackId: row.billPackId,
      };
      Api.getReceiveFile(params7).then((res) => {
        if (res.status === 200) {
          const data = res.data;
          if (data.status === "success") {
            let result = data.result || [];
            const datas = result;
            if (utils.jyCheckObjectType(datas) === "Array") {
              datas.forEach((item) => {
                item.operationType = "UPDATE";
              });
              this.annexTable = datas;
              this.delFilse = false;
              this.isdisabled = true;
              this.uploadAttachmentVisible = true;
            }
          }
        }
      });
    },
    uploadAttachmentConfirm(val) {
      let fileList = [];
      if (val && val.length > 0) {
        val.forEach((item) => {
          let objs = {
            fileId: item.fileId,
            fileName: item.fileName || item.fileId,
            operationType: "ADD",
          };
          fileList.push(objs);
        });
      }
      if (utils.jyCheckObjectType(fileList) === "Array") {
        if (fileList && fileList.length > 0) {
          Api.uploadReceiveFile({
            billPackIds: [this.fileRowData.billPackId],
            files: fileList,
          }).then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (utils.jyCheckObjectType(data) === "Object") {
                ElMessage({
                  message: data.message,
                  type: data.status,
                });
                this.getData();
              }
              this.uploadAttachmentVisible = false;
            }
          });
        } else {
          ElMessage({
            message: "请上传附件",
            type: "error",
          });
        }
      }
    },

    // 付款方式 提货方式
    myGetStatusValList(status, type) {
      Api.getStatusValList({
        tableAndFieldName: status,
      }).then((res) => {
        if (type === 1) {
          //  获取付款方式
          // this.payType = res.data.result || [];
        }
        // if (type === 2) {
        //   //  提货方式
        //   this.handoverModeList = res.data.result || [];
        // }
      });
    },
    getConfDictValDownList(status) {
      //  提货方式
      Api.getConfDictValDownList({
        dictType: status,
      }).then((res) => {
        let resultData = res.data.result || []
        if (status == 'handover_mode') {
          this.handoverModeList = resultData
        }
      })
    },
    // 获取末端派送渠道列表
    getDispatchChannleList(val) {
      return utils.getSelectData("channel_choose_list", 1, [
        {
          conditonKey: "documentStatus",
          conditonVal: "channel_v1_delivery_fee:document_status",
        },
        {
          conditonKey: "handoverMode",
          conditonVal: this.updateFinalHandoverModeDialogData.finalHandoverMode,
        },
      ]).then((res) => {
        this.dispatchChannelOptions = res.arr;
        return res.arr;
      });
    },
    // 获取订舱合作商列表
    getPartnerChannleList(val) {
      let arrs = [{ conditonKey: "partnerName", conditonVal: val }];
      utils.getSelectData("partner_channel_choose_list", 1, arrs).then((res) => {
        this.partnerChannleNameOptions = res.arr;
      });
    },
    // 下拉框数据加载
    visibleChange(val, type) {
      if (val) {
        if (type === 6) {
          utils.getSelectData("partner_channel_choose_list", 1).then((res) => {
            this.partnerChannleNameOptions = res.arr;
          });
        }
      }
    },
    // 表单字段选择器联动
    onSelect(val, arr, type, select) {
      if (type[1]) {
        const obj = utils.jyIDGetContent(arr, select[0], val);
        if (obj) {
          this.outgoingDialogData[type[1]] = obj[select[1]];
        }
      }
      this.outgoingDialogData[type[0]] = val;
    },
  },




};
</script>
  <style scoped lang="scss">
::v-deep .el-date-editor.el-input {
  width: auto !important;
}


// 添加浅蓝色行背景样式
::v-deep .delivery-completed-row {
  background-color: #e6f7ff; // 浅蓝色背景

  &:hover td {
    background-color: #e6f7ff !important;
  }

  td {
    background-color: #e6f7ff !important;
  }
}

.classA {
  display: flex;
}

.glo_dialogForm .diaForm .dialogFormItems {
  height: 30px !important;
  line-height: 30px !important;
  overflow: hidden;
}

.couponBox {
  width: 100%;
  margin-bottom: 20px;
  height: 34px;

  .couponitmeInput {
    width: 100px;
    border: 1px solid #cccccc;
    margin: 0 6px;

    ::v-deep .el-input__inner {
      height: 30px;
      line-height: 30px;
    }
  }

  .couponItemA {
    display: flex;
    align-items: center;
  }
}

.displays {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.rows {
  display: flex;
  width: 100%;
}

.multipleSelect {
  ::v-deep .el-select {
    border: 1px solid #cccccc;
    border-radius: 4px;
  }
}
</style>
  